'use strict';


const SwipeDir = {
    bind: function (el, binding) {
        const opts = Object.freeze(Object.assign({
            right   : false,
            down    : false,
            left    : false,
            up      : false,
            enabled : true,
        }, binding.value || {}));

        if (!opts.enabled) return;

        //
        //  CONFIGURATION
        //

        const PRECISION = 0.20;
        let start       = {screenX: 0, screenY: 0};
        let end         = {screenX: 0, screenY: 0};

        //
        //  PRIVATE FUNCTIONS
        //

        function analyzeGesture (node) {
            if (!node) return false;

            //  Retrieve width/height of the element being used
            const {width, height} = node.getBoundingClientRect();

            //  Calculate ratio changes in comparison to the width/height of the element
            const r_h = (end.screenX - start.screenX) / width;
            const r_v = (end.screenY - start.screenY) / height;

            //  SWIPE RIGHT
            if (opts.right && r_h > r_v && r_h > PRECISION) return 'right';

            //  SWIPE DOWN
            if (opts.down && r_v > r_h && r_v > PRECISION) return 'down';

            //  SWIPE LEFT
            if (opts.left && r_h < r_v && r_h < -PRECISION) return 'left';

            //  SWIPE UP
            if (opts.up && r_v < r_h && r_v < -PRECISION) return 'up';

            return false;
        }

        //
        //  LISTENERS
        //


        el.$athTouchStart = evt => {
            const {screenX, screenY} = evt.changedTouches[0];
            start = Object.assign(start, {screenX, screenY});
        };

        el.$athTouchEnd = evt => {
            const {screenX, screenY} = evt.changedTouches[0];
            end = Object.assign(end, {screenX, screenY});

            //  The event has ended, analyze what we could send out
            const event = analyzeGesture(el, end);
            if (!event || !opts[event]) return;

            MeadCommon.Flash.publish(opts[event]);
        };

        el.addEventListener('touchstart', el.$athTouchStart);
        el.addEventListener('touchend', el.$athTouchEnd);
    },
    unbind: function (el) {
        if (el.$athTouchStart) el.removeEventListener('touchstart', el.$athTouchStart);
        if (el.$athTouchEnd) el.removeEventListener('touchend', el.$athTouchEnd);
    },
};

/**
 * Adds swipe directive to vue. Use with `v-ath-swipe` or `v-mead-swipe`.
 * The `v-ath-swipe` version is deprecated; use `v-mead-swipe` instead.
 */
const SwipeDirective = {
    bind: function (vue) {
        vue.directive('athSwipe', SwipeDir);
        vue.directive('meadSwipe', SwipeDir);
    }
}

export default SwipeDirective;
